import getLockingSystemPricePortions, {
	getLockingSystemMsrpPricePortions,
} from "../utils/getLockingSystemPricePortions"
import getPricePortions from "@secureo/common/reducers/productDetailPageReducer/utils/getPricePortions"
import getMsrpPricePortions from "@secureo/common/reducers/productDetailPageReducer/utils/getMsrpPricePortions"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"
import { CountryCode } from "@secureo/common/typings/CountryCode"
import { LockingSystemComponent } from "@secureo/common/typings/LockingSystem"

type SetComponentQuantityPayload = Pick<
	LockingSystemReducerState,
	| "componentsByUuid"

	// Price
	| "singleNetPriceCents"
	| "singleGrossPriceCents"
	| "totalNetPriceCents"
	| "totalGrossPriceCents"

	// Msrp price
	| "singleNetMsrpPriceCents"
	| "singleGrossMsrpPriceCents"
	| "totalNetMsrpPriceCents"
	| "totalGrossMsrpPriceCents"
>

const getUpdatedComponent = (
	component: LockingSystemComponent,
	quantity: number,
	taxRate: number,
	countryCode: CountryCode,
) => {
	const {
		variantsByVariantId,
		variantId,
		cylinderConfigurationVariant,
		configurationsByConfigurationGroup,
	} = component

	const pricePortions = getPricePortions(
		variantsByVariantId,
		variantId,
		taxRate,
		quantity,
		countryCode,
		configurationsByConfigurationGroup,
		cylinderConfigurationVariant,
	)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
		msrpPricePortions,
	} = getMsrpPricePortions(
		quantity,
		taxRate,
		countryCode,
		component.attributes,
		configurationsByConfigurationGroup,
	)

	return {
		...component,
		quantity,
		...pricePortions,
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		msrpPricePortions,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}
}

export const setComponentQuantity = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuid: string,
	quantity: number,
) => {
	const { taxRate, countryCode } = reducerState

	const updatedComponent = getUpdatedComponent(
		reducerState.componentsByUuid[uuid],
		quantity,
		taxRate,
		countryCode,
	)

	const componentsByUuid = {
		...reducerState.componentsByUuid,
		[uuid]: updatedComponent,
	}

	const { singleNetPriceCents, singleGrossPriceCents, totalNetPriceCents, totalGrossPriceCents } =
		getLockingSystemPricePortions(componentsByUuid, reducerState.quantity)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	} = getLockingSystemMsrpPricePortions(componentsByUuid, reducerState.quantity)

	const payload: SetComponentQuantityPayload = {
		componentsByUuid,
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}

	dispatch({
		type: "SET_COMPONENT_QUANTITY",
		payload,
	})
}
